const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);
const DEFAULT_LOCAL_ASSISTANT_URL = "http://127.0.0.1:8765";

export function isPrivateLocalAssistantEnabled() {
  return LOCAL_HOSTS.has(window.location.hostname);
}

export async function askPrivateLocalAssistant(message, conversationContext = "") {
  if (!isPrivateLocalAssistantEnabled()) {
    throw new Error("private_local_only");
  }

  const configured = String(process.env.REACT_APP_LOCAL_ASSISTANT_URL || "").trim();
  const baseUrl = (configured || DEFAULT_LOCAL_ASSISTANT_URL).replace(/\/$/, "");
  const response = await fetch(`${baseUrl}/v1/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      message,
      conversation_context: conversationContext || undefined,
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || typeof data.answer !== "string") {
    throw new Error(data.error || "local_assistant_unavailable");
  }
  return data;
}
